import { useRef, useCallback } from 'react'
import { useConversionScopedStore } from '../../../store/scoped'

export const useInputsController = () => {
  const debitInputRef = useRef<HTMLInputElement>(null)
  const creditInputRef = useRef<HTMLInputElement>(null)

  const setInputController = useConversionScopedStore(
    (state) => state.setInputController,
  )

  const onFocus = useCallback(
    (inputType: 'debit' | 'credit') => {
      setInputController({
        lastFocusedInput: inputType,
        debitInputRef,
        creditInputRef,
      })
    },
    [setInputController],
  )

  return {
    debitInputRef,
    creditInputRef,
    onFocus,
  }
}
